<template>
	<div>
		<div class="van-hairline--bottom r-title">订单信息</div>
		<div style="font-size: 15px;">
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">订单编号：</span>
				<span style="flex: 1;text-align: left;">{{order.out_trade_no}}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">订单状态：</span>
				<span style="flex: 1;text-align: left;">{{order.order_state}}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;"  >
				<span style="width: 30%;text-align: right;">付款时间：</span>
				<span v-if="order.pay_time" style="flex: 1;text-align: left;">{{order.pay_time*1000 | formonment('YYYY-MM-DD HH:mm:ss') }}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">取货时间：</span>
				<span v-if="order.pickup_time" style="flex: 1;text-align: left;">{{order.pickup_time*1000 | formonment('YYYY-MM-DD')}}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">订单金额：</span>
				<span style="flex: 1;text-align: left;" ><span v-if="order.total_fee">￥</span>{{order.total_fee}}</span>
			</div>
			<div style="display: flex;" v-if="order.full_refund">
				<span style="width: 30%;text-align: right;">已退金额：</span>
				<span style="flex: 1;text-align: left;">￥{{order.full_refund}}</span>
			</div>		
		
		</div>
		<div class="van-hairline--bottom r-title">退款类型</div>
		<div style='padding: 10px 0;'>			
			<div v-if="order.is_full_refund == 2 && order.is_part_refund == 2" >
				 <span style="color:red;">{{order.not_reason}}</span>
			</div>
			<van-radio-group v-model="returnType" direction="horizontal" style="display: flex;justify-content: center;" v-else>
			  <van-radio name="part" :disabled='order.is_part_refund == 2' style="margin-right: 50px;" checked-color="#ee0a24">指定商品退款</van-radio>
			  <van-radio name="full" :disabled='order.is_full_refund == 2' checked-color="#ee0a24">全单退款</van-radio>
			</van-radio-group>
		</div>
		<div v-if="returnType == 'full'" class="van-hairline--bottom" style="display: flex;justify-content: space-between;padding: 10px 20px;margin: 10px 0;">
			<div style="font-size: 16px;font-weight: 800;">退款原因</div>
			<div @click='chooseReason' ><span style="color: red;" v-if="!reason.id">*</span> {{reason.id ? reason.text:'请选择退款原因'}}<van-icon name="arrow" /></div>
		</div>
		<div>
			
		</div>
		<div class="van-hairline--bottom r-title">商品信息</div>
		<div style="padding-bottom: 100px;">
			<div style="display: flex;align-items: center;text-align: left;background-color: #fafafa;margin-bottom: 10px;box-sizing: border-box;" v-for="(item,index) in orderDetail" :key="index">
				<van-checkbox v-model="item.checked" style="box-sizing: border-box;padding-left: 10px;" checked-color="#ee0a24" @click='checkGoods(item)' :disabled='item.is_can_refund== 2' v-if="order.is_part_refund == 1 && returnType == 'part' "></van-checkbox>
				<van-card
				  :price="item.price.toFixed(2)"
				  :desc="item.size ? item.size +'/'+item.unit_name:''"
				  :title="item.name"
				  :thumb="item.thumb_image"
				  style="flex: 1;"
				>
				<template #tags>
				    <div style="display: flex;justify-content: space-between;align-items: center;">
						<span style="color: red;" v-if="item.return_quantity">已退{{item.return_quantity}}件</span>
						<div style="flex: 1;display: flex;justify-content:flex-end;">
							<van-stepper v-if="item.checked " v-model="item.returnQuantity" :max='item.quantity-item.return_quantity' @change='changeGoodsNum(item)' />					
							<div style="height: 28px;display: flex;align-items: center;font-size: 14px;"  v-else>
								<span>*{{item.quantity}}</span>
							</div>
						</div>
						
					</div>				    
				  </template>
				  <template #footer >
					  <div v-if="item.checked" style="margin-top: 10px;">
						 <van-button size="mini" style="font-size: 13px;" @click='openUploadPop(item)'>{{ item.returnImgList.length ? '已上传图片' :'上传图片'}}<van-icon v-if="item.returnImgList.length" name="checked" color="green"/></van-button>
						 <van-button size="mini" style="font-size: 13px;" @click='openChooseReason(item)'><span style="color: red;" v-if="!item.returnReasonId">*</span> {{item.returnReasonText ? item.returnReasonText:'选择退货原因'}}<van-icon v-if="item.returnReasonId" name="checked" color="green"/></van-button> 
					  </div>					   
				  </template>
				</van-card>
				
			</div>
		</div>
		
		<van-submit-bar v-if="returnTotal.newAcount != 0.00" :price="returnTotal.newAcount*100" button-text="申请退款" @submit="onSubmit" label='退款合计:' />
		<van-popup v-model="returnReasonShowPicker" round position="bottom">
		  <van-picker
		    show-toolbar
		    :columns="returnReasons"
			value-key='reason'
		    @cancel="onCancelReason"
		    @confirm="onConfirmReason"
		  />
		</van-popup>
		<van-popup v-model="uploadImgShow" position='top' round :close-on-click-overlay='false'>
			<div style="padding: 20px 0 0 0;">
				<div style="margin-bottom: 10px;">最多可上传3张</div>
				<div style="padding: 10px 20px;">
					<van-uploader :after-read="afterRead" v-model="fileList" :max-count="3" @delete='deleteImg' />
				</div>
				
				<div style="display: flex;align-items: center; text-align: center;border-top: 1px solid #ffffff;color: #ffffff; ">
					<div style="width: 50%;border-right: 1px solid #ffffff; padding: 10px 0;background-color: #1e90ff;" @click='cancelUpload'>取消</div>
					<div style="width: 50%;padding: 10px 0;background-color: #ff4757; " @click='confirmUpload'>确认</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default{
		name:'returnOrder',
		data(){
			return{
				returnType:null,//退款类型
				order:{},//订单详情
				orderDetail:[],//商品详情			
				returnReasonShowPicker:false,//退款原因选择器开关				
				returnReasons:[],//退款原因列表
				currentItem:{},//当前操作商品
				uploadImgShow:false,//上传图片开关
				fileList: [],//已上传列表
				reason:{//整单退款的原因
					id:'',
					text:''
				}
			}
		},
		computed:{
			//选中要退款的商品数组
			checkedArr(){
				let arr = this.orderDetail.filter(item=>{
					return item.checked
				})
				return arr
			},
			//要退款的总计金额
			returnTotal(){
				let obj = {}
				//如果选择全单退款
				if(this.returnType == 'full'){
					obj.newAcount = (this.order.total_fee - this.order.full_refund).toFixed(2)
				}else{					
					obj.newAcount = this.checkedArr.reduce((sum,item)=>sum+(item.returnQuantity*item.price),0)
					obj.newAcount = obj.newAcount.toFixed(2)
				}							
				return obj
			}
		},
		methods:{
			//打开全单退款原因
			chooseReason(){
				this.returnReasonShowPicker = true;		
			},
			//打开退款原因弹窗
			openChooseReason(item){
				this.currentItem = item
				this.returnReasonShowPicker = true;				
			},
			//确认退款原因
			onConfirmReason(value) {			
				  if(this.returnType == 'part'){
					  this.currentItem.returnReasonId = value.id //赋值要退款的原因id
					  this.currentItem.returnReasonText = value.reason //赋值要退款的原因文本
				  }else{
					  this.reason.id = value.id;
					  this.reason.text = value.reason
				  }
				 
			      this.returnReasonShowPicker = false;
			    },
			//取消退款原因
			onCancelReason(){
				// if(this.returnType == 'part'){
				// 	this.currentItem.returnReasonId = null //重置退款原因id为空
				// 	this.currentItem.returnReasonText = null //重置退款原因文本为空
				// }else{
				// 	this.reason.id ='';
				// 	this.reason.text = ''
				// }
				
				this.returnReasonShowPicker = false;
			},
			
			//打开上传图片弹窗
			openUploadPop(item){
				//先把fileList清空
				this.fileList = []
				this.currentItem = item
				this.fileList = this.currentItem.returnImgList				
				this.uploadImgShow = true
				// console.log(this.fileList)
			},
			afterRead(file,detal){	
				
			},
			deleteImg(file,detal){
				//删除图片的时候如果是已上传的，就把这个商品的相对应的图片也删掉
				if(file.isUpload){
					let index = detal.index
					this.currentItem.returnImgList.splice(index,1)
				}				
			},
			//点击确认上传按钮
			confirmUpload(){
				if(!this.fileList.length){
					this.uploadImgShow = false
					return
				}
				//创建一个new FormData
				const fd = new FormData()
				fd.append('img_type','order_refund')
				let arr = []
				this.fileList.map(item=>{				 
					if(item.status == ''){				
						arr.push(item)
					}
				})
				if(arr.length){
					arr.forEach(item=>{
						 fd.append('image[]',item.file)	
					})
				}else{
					this.uploadImgShow = false
					return
				}
				//关闭上传pop框
				this.uploadImgShow = false
				
				//创建一个上传加载弹窗
				 const toast=this.$toast.loading({
				   message: '上传中...',
				   forbidClick: true,
				   loadingType: 'spinner',
				   duration:0
				 });
				 console.log(fd)
				 //请求接口上传
				this.request.postURL('/api/admin/services/uploadimage',
				fd
				).then(res=>{													
					//把已上传的图片添加到商品的已上传属性中，再次打开上传按钮的时候用于回显
					let result = res.data.data
					result.forEach(item=>{
						this.currentItem.returnImgList.push({
							url:item.imgUrl,
							isUpload:true //标记该张图片已经上传
						})
					})
					//弹窗消失
					toast.clear();
					//弹出上传成功提示
					this.$toast.success({
					  message: res.data.msg,					 
					});
					
				}).catch(err=>{
					//弹窗消失
					toast.clear();
					console.log(err)
				})
			},
			//点击确定的时候才是确认上传了,可以回显
			//点击取消,不用回显
			
			//取消上传
			cancelUpload(){
				this.uploadImgShow = false
				this.fileList=[]
			},
			//勾选要退款的商品，
			checkGoods(item){		
				// 不勾选则重置
				// if(item.checked == false){
				// 	item.returnQuantity = null//重置退货数量为1
				// 	item.returnReasonId= null //重置退款原因ID
				// 	item.returnReasonText = null //重置退款原因文本
				//	item.returnImgList = [] //重置退款图片
				// }
			},
			//选择要退款的数量
			changeGoodsNum(item){
				//console.log(item.returnQuantity)
			},
			//获取订单详情
			getOrderDetail(id){
				const toast=this.$toast.loading({
				  message: '',
				  forbidClick: true,
				  loadingType: 'spinner',
				});
				  this.request.postURL('/api/RefundOrder/getOrderDetail',{
					  id:id
				  }).then(res=>{
					  toast.clear()
						this.order = res.data.data;						
						this.orderDetail = res.data.data.order_detail	
						
					  //只能全单退，不能单个退
					  if(this.order.is_full_refund == 1 && this.order.is_part_refund == 2){
						  this.returnType = 'full'
					  }
					  //只能单个退，不能整单退
					  if(this.order.is_full_refund == 2 && this.order.is_part_refund == 1 ){
						 this.returnType = 'part'
					  }
					  //既能整单退，又能单个退
					  if(this.order.is_full_refund == 1 && this.order.is_part_refund == 1){
						  this.returnType = 'part' 
					  }
					  
				  }).catch(err=>{
					  toast.clear()
				  })
			},
			//获取退款退货原因
			getReturnReason(){
				this.request.postURL('/api/RefundOrder/getReturnReason',{
				}).then(res=>{
					this.returnReasons = res.data.data.return_reason
				}).catch(err=>{
					
				})
			},
			//提交退款订单
			onSubmit(){	
				let arr = []
				//全部退款
				if(this.returnType == 'full'){
					if(!this.reason.id){
						this.$toast.fail({
						  message: '请选择退货原因后提交！',
						  forbidClick: true,
						  duration:3000
						});
						return
					}
				}else{
					//部分退款商品数据
					for(var i= 0;i<this.checkedArr.length;i++){
						if(!this.checkedArr[i].returnReasonId){
							this.$toast.fail({
							  message: this.checkedArr[i].name+'，请选择退货原因！',
							  forbidClick: true,
							  duration:3000
							});
							return
						}
					}
					
					this.checkedArr.map(item=>{						
						//商品上传图片
						let imgs = []
						if(item.returnImgList.length){
							imgs= item.returnImgList.map(item=>{
								return item.url
							})
						}										
						arr.push({
							goods_id:item.goods_id,
							return_quantity:item.returnQuantity,
							return_reason_id:item.returnReasonId,
							return_img:imgs,
						})
					})
				}
				
				const toast =this.$toast.loading({
				  message:'正在提交...',
				  forbidClick: true,
				  duration:0
				});
				
				//请求提交接口
				this.request.postURL('/api/RefundOrder/refundOrder',{
					id:this.order.id,
					type:this.returnType,
					goods:this.returnType == 'full' ? [] : arr,
					return_reason_id:this.returnType == 'full' ? this.reason.id : 0 ,
				}).then(res=>{
					toast.clear()
					//弹出确认框
					this.$dialog.alert({
					    message: res.data.data.action,
					}).then(()=>{
						this.$router.go(-1) //返回上一页
					})
					
				}).catch(err=>{
					console.log(err)
				})
			},
		},
				
		mounted() {
			this.getReturnReason()
		},
		watch:{
			returnType(){			
				if(this.returnType == 'full'){
					this.orderDetail.forEach(item=>{
						this.$set(item,'checked',false) //增加check属性					
					})
				}else{
					this.orderDetail.forEach(item=>{
						this.$set(item,'checked',false) //增加check属性
						this.$set(item,'returnQuantity',1)//增加退款数量属性
						this.$set(item,'returnReasonId',null)//增加退款原因id属性
						this.$set(item,'returnReasonText',null)//增加退款原因文本属性
						this.$set(item,'returnImgList',[])//增加退款图片属性
					})
				}
			}
		},
		created() {
			var id =this.$route.query.id
			this.getOrderDetail(id)					
		}
		
		
	}
</script>

<style scoped>
	.r-title{
		text-align: left;
		font-size: 16px;
		font-weight: 800;
		padding:10px 20px;
		margin: 10px 0;
	}
</style>